// @file Avatar anchor element ids, kept dependency-free so app bars outside the surface can import them cheaply.

/**
 * ID for the avatar button element used as anchor for guest ID card or user menu popover.
 * This should be assigned to the avatar button in both SurfaceTopBar and SurfaceActionBar.
 */
export const AVATAR_EL_ID = 'guest-id-card-avatar-anchor'

/**
 * ID for the avatar button on SurfaceStickyTopBar. Resolved separately from AVATAR_EL_ID so
 * SurfacePanels can prefer the sticky anchor when the sticky bar is revealed (the regular bar's
 * avatar is still in the DOM but scrolled offscreen).
 */
export const STICKY_AVATAR_EL_ID = 'sticky-top-bar-avatar-anchor'
